import {isInViewport, raf} from "./util";

export function registerTabs() {
    raf(() => {
        Array.from(document.querySelectorAll("div.tab-container")).forEach(tc => {
            const content = tc.querySelector("div.tab-container-content");
            const tabBar = tc.querySelector("ul.tab-container-tabs");

            const contents = Array.from(content.querySelectorAll("div.tab-content"));
            const tabs = Array.from(tabBar.querySelectorAll("li.nav-item"));

            tabs.forEach(tab => tab.addEventListener("click", evt => {
                evt.preventDefault();

                const target = tab.querySelector("a.nav-link").dataset.target;

                contents.forEach(c => c.style.setProperty("display", "none"));
                content.querySelector(target).style.setProperty("display", "block");

                tabs.forEach(t => t.classList.remove("active"));
                tab.classList.add("active");
            }));

            const onScroll = () => {
                if (!isInViewport(content))
                    return;

                window.removeEventListener("scroll", onScroll);

                let currentTab = tabs.find(t => t.classList.contains("active"));
                currentTab = currentTab || tabs[0];
                currentTab.click();
            };

            window.addEventListener("scroll", onScroll, {passive: true});

            onScroll();
        });
    });
}
